import { Colors } from '../consts/Colors.js';

export default class Popup extends Phaser.GameObjects.Container {
    constructor(scene, txt, label, onCompleteFunc) {
        super(scene, scene.width / 2, scene.height / 2);
        scene.add.existing(this);
        this.scene = scene;
        this.txt = txt;
        this.label = label;
        this.onCompleteFunc = onCompleteFunc || (() => { });


        this.back = this.scene.add.rexRoundRectangle(0, 0, 1008, 261, 20, Colors.Elmt.White);
        this.add(this.back);

        this.text = this.scene.add.rexTagText(0, 0, txt, {
            fontSize: "40px",
            fontFamily: "Binx",
            align: "center",
            color: Colors.Text.DarkBlue,
            backgroundColor: 'transparent',
            wordWrap: { width: 924 },
        }).setOrigin(0.5);

        if (this.label !== undefined) {
            this.labelIllu = this.scene.add.image(0, -261 / 2 - 30, this.label).setOrigin(0.5).setAlpha(0).setScale(100)
            this.labelIllu.setAngle(-1);
            this.add(this.labelIllu);
        }

        this.add(this.text);

        this.setScale(0)

    }

    launchAnim() {
        this.scene.tweens.add({
            targets: [this],
            duration: 500,
            ease: 'Cubic.easeInOut',
            scale: 1,
            onComplete: () => {
                this.scene.popupOn = true;
                if (this.label !== undefined) {
                    this.scene.tweens.add({
                        targets: [this.labelIllu],
                        duration: 200,
                        ease: 'Cubic.easeInOut',
                        alpha: 1,
                        scale: 1
                    });
                }
                this.onCompleteFunc(this.scene)
            }
        });
    }
}
